var _rect, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAnnotationReviewRemoved = function SvgAnnotationReviewRemoved(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    rx: 4,
    fill: "currentColor",
    fillOpacity: 0.18
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.75732,
    y: 6.34314,
    width: 14,
    height: 2,
    rx: 1,
    transform: "rotate(45 7.75732 6.34314)",
    fill: "#DD0000"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 2,
    rx: 1,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 16.2427 6.34314)",
    fill: "#DD0000"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAnnotationReviewRemoved);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "annotation-review-removed.bc77529cd2cb5b25255dd5a640485fdd.svg";